import React from 'react';
import IconButton from '../IconButton/IconButton';
import { BlockForDeactivatedUser } from '../BlockForDeactivatedUser/BlockForDeactivatedUser';
import { getNewArticlePageUrl } from '../../services/pagesUrl/getNewArticlePageUrl';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';

const NavbarNewArticlePostLink = () => {
  const { sendEvent } = useAnalytics();
  const handleClick = () => sendEvent('navbar_new_post_button_click');

  return (
    <BlockForDeactivatedUser>
      <IconButton
        tag="a"
        href={getNewArticlePageUrl()}
        color="secondary"
        className="md:hidden before:content-plus before:h-[20px]"
        onClick={handleClick}
      />
    </BlockForDeactivatedUser>
  );
};

export default NavbarNewArticlePostLink;
